export const VIDEO_ALL_TAB = 'video-all-tab';
export const VIDEO_MY_TAB = 'video-my-tab';
export const VIDEO_SHARED_TAB = 'video-shared-tab';

export const PCN_PUT_VIDEO = 'put/video';

export const WEAVO_WATCH_PLAYLIST = 'weavo_watch_playlist';
export const WEAVO_WATCH_DEEP_SEARCH = 'weavo_watch_deep_search';
export const WEAVO_WATCH_COMMENTS = 'weavo_watch_comments';
export const WEAVO_WATCH_HIGHLIGHTS = 'weavo_watch_highlights';

export const WEAVO_TEAM_SHARE = 'weavo_internal_share';

export const INVITATIONS_EXTERNAL_SHARE = 'invitations-external-share';
export const GET_INVITATIONS = 'get/invitations';
export const POST_INVITATIONS = 'post/invitations';
export const DELETE_INVITATIONS = 'delete/invitations';

export const WEAVO_DOWNLOAD_VIDEO_FROM_WATCH = 'weavo_download_video_from_watch';
